<template>
	<div>
		<div class="d-flex align-items-center">
			<div class="mcqtophead">
				Difficulty Level - {{ data.difficultyLevel }}
			</div>
			<div class="mcqtophead">{{ data.marks }} Mark</div>
			<div class="mcqtophead">Category: {{ data.category }}</div>
		</div>

		<div class="questiontext">
			<div class="d-flex">
				<span class="mr-2">Q{{ showindex }}.</span
				><span class="topicDescBreak" v-html-safe="data.question"></span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "code",
	props: {
		data: Object,
		showindex: Number,
	},
};
</script>
